module.exports = __webpack_public_path__ + "media/src/assets/fonts/mplus-1p-black-8c0ca46569e401e68f509709c6a52bf2.ttf";